import React, { useEffect } from 'react';
import { ConfirmModalComponent } from './ConfirmModal';
import { AlertModalComponent } from './AlertModal';
import { AlertModalProps, ConfirmModalProps } from './Modal.type';
import { alert$ } from './Modal.service';

export const ModalContainerComponent = () => {

    const [alerts, setAlerts] = React.useState<AlertModalProps[]>([]);
    const [confirms, setConfirms] = React.useState<ConfirmModalProps[]>([]);
    useEffect(() => {
        alert$.subscribe((data: any) => {
            setAlerts(data.alerts);
            setConfirms(data.confirms);
        });
    })

    return (
        <>
            {confirms && confirms.map((confirm) => {
                return (
                    <ConfirmModalComponent key={confirm.id} {...confirm} />
                );
            })}
            {alerts && alerts.map((alert) => {
                return (
                    <AlertModalComponent key={alert.id} {...alert} />
                );
            })
            }
        </>
    );
};
